<template>
  <div id="development-history" class="development-history-wrapper">
    <div class="development-history-title">
      {{ config.title }}
    </div>
    <div class="timeline-wrapper">
      <div v-for="(item,index) in listData" :id="`timeline-item-${index+1}`" :key="index" class="timeline-item">
        <div class="timeline-card">
          <div class="timeline-card-time">
            {{ item.time }}
          </div>
          <div class="timeline-card-content">
            <div v-for="(caseItem,caseIndex) in item.cases" :key="`case-${caseIndex}`" class="timeline-card-case">
              {{ caseItem }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="expand-collapse-btn" @click="expandList">
      <i class="iconfont icon-arrow-bottom" :style="`transform: rotate(${isExpand?'180':'0'}deg)`" />
      <div class="expand-collapse-text">
        {{ isExpand?config.btnText[0]:config.btnText[1] }}
      </div>
    </div>
  </div>
</template>

<script>
import skrollTop from 'skrolltop';

export default {
  props: {
    config: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      listData: [],
      isExpand: false,
      timelineHeight: 0,
      subTimelineHeight: 0,
    }
  },
  mounted() {
    this.listData = this.config.listData.slice(0, 5);
  },
  methods: {
    expandList() {
      if (this.isExpand) {
        this.listData = [].concat(this.config.listData.slice(0, 5));
        this.isExpand = false;
        skrollTop.scrollTo({
          to: document.getElementById('development-history').offsetTop,
        });
      } else {
        this.listData = [].concat(this.config.listData);
        this.isExpand = true;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.development-history-wrapper {
  margin: 0 auto;
  padding: 120px 0 60px;
  width: 680px;

  .development-history-title {
    margin-bottom: 56px;
    font-size: 48px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 56px;
    text-align: center;
  }

  .timeline-wrapper {
    transition: height 1s;

    .timeline-item {
      position: relative;
      padding: 12px 0;
      border-left: 1px #e1e1e1 dashed;

      .timeline-card {
        margin-left: 30px;
        background: #fbfcff;
        border-radius: 16px;
        border: 1px solid rgba(162, 170, 184, 0.19);
      }

      .timeline-card-time {
        padding: 24px 24px 8px;
        font-size: 32px;
        font-weight: 600;
        color: rgba(23, 43, 77, 1);
        line-height: 45px;
        border-bottom: 2px rgba(0, 0, 0, 0.05) dashed;
      }

      .timeline-card-content {
        padding: 15px 24px 16px;
        font-size: 20px;
        font-weight: 500;
        color: rgba(23, 43, 77, 0.5);
        line-height: 28px;
      }

      .timeline-card-case {
        margin-bottom: 8px;
      }

      &::before {
        position: absolute;
        z-index: 2;
        top: 50%;
        transform: translate(-50%, -50%);
        content: '';
        width: 13px;
        height: 13px;
        background: #e1e1e1;
        border-radius: 50%;
      }
    }

    & :first-child .timeline-card {
      background: var(--txt-color-link);
      border: none;

      & .timeline-card-time {
        color: rgba(255, 255, 255, 1);
        border-bottom: 2px rgba(255, 255, 255, 0.2) dashed;
      }

      & .timeline-card-content {
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .timeline-wrapper > :first-child::after,
  .timeline-wrapper > :last-child::after {
    position: absolute;
    z-index: 1;
    left: -10px;
    content: '';
    width: 20px;
    height: 50%;
    background: #fff;
  }

  .timeline-wrapper > :first-child::after {
    top: 0;
  }

  .timeline-wrapper > :last-child::after {
    top: 50%;
  }

  .timeline-wrapper > :first-child::before {
    background: var(--txt-color-link);
  }

  .expand-collapse-btn {
    margin-top: 24px;
    text-align: center;
    cursor: pointer;

    .icon-arrow-bottom {
      display: inline-block;
      font-size: 25px;
      color: rgba(162, 170, 184, 1);
      transition: all 1s;
    }

    .expand-collapse-text {
      font-size: 18px;
      font-weight: 600;
      color: var(--txt-color-lv2);
      line-height: 25px;
    }
  }
}
</style>
